/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ShowDismissed/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaCheckboxWithInputText from 'DesignSystem/TysiaCheckboxWithInputText/index'



/** @type {import('Simple/types.js').View} */
export default function ShowDismissed({
  children,
  viewPath = "/App/Account/Content/Marketing/ShowDismissed",
  onChange
  
}) {
let tabSelectedShowDismissedValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.show_dismissed',
})
let tabSelectedShowDismissedChangeData = fromData.useDataChange({ viewPath,
context: 'tab',
path: 'selected.show_dismissed',
})
  return (<React.Fragment
>
<TysiaCheckboxWithInputText
  viewPath={`${viewPath}/TysiaCheckboxWithInputText`}
 text="Show dismissed leads"
 data="tab.selected.show_dismissed"
 value={tabSelectedShowDismissedValueData}
 onChange={tabSelectedShowDismissedChangeData}
/>
{children}
</React.Fragment>)
}